/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Button, Stack, SxProps, Theme, Typography } from "@mui/material";
import { serviceworldHeroStyle } from "@/src/components/Sections/Generic/ServiceworldHero/serviceworldHeroStyle";
import Container from "@/src/components/Container/Container";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";
import { useTheme } from "@mui/material/styles";
import Section from "@/src/components/Section/Section";

export default function ServiceworldHero() {
  const { setView } = useAuthDialog();
  const theme = useTheme();

  return (
    <Section sx={serviceworldHeroStyle.serviceworldHero}>
      <Container variant={"xs"}>
        <Typography variant={"h1"} align={"center"} sx={{ marginBottom: "1.5rem" }}>
          Recht leicht gemacht
        </Typography>
        <Typography
          align={"center"}
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            marginBottom: "2rem",
          })}
        >
          Rechtliche Sicherheit, wenn Sie sie brauchen!
          <br /> Unser Fokus: Ihr persönlicher Erfolg. Unser Fundament: Langjährige Erfahrung. Unser Vorteil: Neueste Technologie.
        </Typography>
        <Stack direction={"column"} useFlexGap sx={serviceworldHeroStyle.actions}>
          <Button variant={"contained"} onClick={() => setView({ type: "login" })}>
            Anmelden
          </Button>
          <Button variant={"outlined"} onClick={() => setView({ type: "register" })}>
            Registrieren
          </Button>
        </Stack>
      </Container>
      <picture>
        <source
          media={`(min-width: ${theme.breakpoints.values.sm}px)`}
          srcSet={"/img/serviceworld-hero/serviceworld-hero-desktop.png"}
          width={2506}
          height={1288}
        />
        <Box
          component={"img"}
          src={"/img/serviceworld-hero/serviceworld-hero-mobile.png"}
          alt={""}
          sx={serviceworldHeroStyle.image}
          width={642}
          height={1254}
        />
      </picture>
    </Section>
  );
}
